import React, { useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';
import './index.css';

const JoditEditorComponent = ({ value, onChange, placeholder }) => {
  const editor = useRef(null);

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: placeholder || 'Start typing...',
      height: 400,
      minHeight: 300,
      toolbar: true,
      spellcheck: true,
      language: 'en',
      toolbarButtonSize: 'middle',
      toolbarAdaptive: false,
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      buttons: [
        'source',
        '|',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        '|',
        'ul',
        'ol',
        '|',
        'outdent',
        'indent',
        '|',
        'font',
        'fontsize',
        'brush',
        'paragraph',
        '|',
        'image',
        'link',
        'table',
        '|',
        'align',
        'undo',
        'redo',
        '|',
        'hr',
        'eraser',
        'copyformat',
        '|',
        'symbol',
        'fullsize',
        'preview',
      ],
      uploader: {
        insertImageAsBase64URI: true
      },
      removeButtons: [],
      disablePlugins: [],
      events: {},
      textIcons: false,
    }),
    [placeholder]
  );

  return (
    <div className="jodit-editor-wrapper">
      <JoditEditor
        ref={editor}
        value={value || ''}
        config={config}
        tabIndex={1}
        onBlur={(newContent) => onChange(newContent)}
        onChange={(newContent) => {}}
      />
    </div>
  );
};

export default JoditEditorComponent;

